import { Fragment, useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import SDK from "../config";
import TrackingScripts from "../Components/checkoutPageComponent/trackingComponent";
import postVisitorsData from "../Components/web/visitors";
import { images } from "../Constants/imageslinks.js";
import Header from "../Components/ui/header.jsx";
import MenuComponent from "../Components/reservationPageComponents/menuComponent.jsx";
import Footer from "../Components/ui/footer.jsx";

const ReservationPage = () => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const email = params.get("email");
  const navigate = useNavigate();
  const eventId = `event-${new Date().getTime()}`;
  // const saveRegion = localStorage.getItem("region") || "us";

  const [currRegion, setCurrRegion] = useState("");
  const DiscountedPrice = SDK.FB_PRICE - SDK.FB_DISOUNT_PRICE;
  const finalDiscountedPrice = Number(DiscountedPrice.toFixed(2));

  useEffect(() => {
    if (window.mootrack) {
      window.mootrack("Reservation Page", email);
    }

    // Lead Generation Tracker
    if (window.twq) {
      window.twq("event", "tw-qmokf-qmokh", {
        email_address: email,
      });
    }
    const region = localStorage.getItem("region");
    if (region === "uk" || region === "eu") {
      setCurrRegion(`${region}`);
    } else {
      setCurrRegion("");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const [regionText, setRegionText] = useState(SDK.REGION_CONFIG.us);

  const clickCountMeIn = () => {
    let pathToNav =
      currRegion !== ""
        ? `/${currRegion}/payment-checkout?email=${encodeURIComponent(email)}`
        : `/payment-checkout?email=${encodeURIComponent(email)}`;
    navigate(pathToNav);

    if (window.fbq) {
      window.fbq("track", "AddToCart", { event_id: eventId });
    }
    if (window.mootrack) {
      window.mootrack("AddToCart", email);
    }
    // if (window.ttq) {
    //   window.ttq.track("AddToCart", { event_id: eventId });
    // }

    // Add to Cart Tracker
    if (window.twq) {
      window.twq("event", "tw-qmokf-qmokj", {
        value: 5.0,
        currency: "USD",
      });
    }
    console.log("reservation page twq: ", window.twq);

    const lead = true;
    const addtocart = true;
    const purchase = false;
    const amount = null;
    const tagsString = "Android Website";
    postVisitorsData({
      email,
      lead,
      addtocart,
      purchase,
      amount,
      tags: tagsString,
    });
  };

  return (
    <Fragment>
      <TrackingScripts />
      <div>
        <div className="bg-primary200">
          <div className="lg:hidden">
            <Header />
          </div>
          <div className="3xl:container 3xl:mx-auto bg-primary300 lg:grid grid-cols-12 flex flex-col-reverse">
            <div className="lg:min-h-screen lg:px-[7vw] md:px-8 px-4 3xl:px-[110px] col-span-7">
              <div className="py-[45px] hidden lg:block">
                <img src={images.minimis_logo} alt="minimis logo" />
              </div>

              <div className="flex flex-col items-start md:gap-[37px] gap-6 md:pt-[20px] pt-[30px] pb-[30px]">
                <p className="font-light text-[32px] leading-12 text-secondary100">
                  Welcome! Get 40% off your first year for{" "}
                  {regionText.currSymbol ?? "$"}
                  {finalDiscountedPrice}
                  &nbsp;
                  {(regionText.currency ?? "USD").toUpperCase()}
                </p>
                <div className="font-normal text-base leading-6 text-secondary100 flex flex-col gap-[18px]">
                  <p>
                    Today's your lucky day! We charge $49.99 yearly on the app
                    store.
                  </p>
                  <p>
                    For less than a cup of coffee ($2.50), save up to 120 hours
                    every month.
                  </p>
                  <p>
                    Get a dumbphone experience for a fraction of the cost,
                    without sacrificing the utility of your smartphone or
                    needlessly polluting the environment.
                  </p>
                </div>
                <button
                  onClick={clickCountMeIn}
                  className="w-full lg:max-w-[411px] bg-secondary100 rounded-sm font-medium text-base leading-[100%] text-primary100 p-3"
                >
                  Redeem my discount
                </button>
              </div>
            </div>

            <MenuComponent />
          </div>

          <div className="px-5 py-5 flex flex-col gap-4 lg:hidden">
            <div className="bg-primary100 rounded-lg p-6 flex gap-3 items-start">
              <img src={images.hands_icon} alt="refund icon" />
              <div className="flex flex-col gap-3">
                <p className="font-light md:text-2xl text-lg md:leading-[100%] leading-[25px] text-secondary100">
                  7-day full refund guarantee
                </p>
                <p className="font-light md:text-base text-sm md:leading-[21px] leading-[19px] text-secondary100 max-w-[537px]">
                  Not a fan? No problem. Email us for a full refund within 7
                  days of purchase.
                </p>
              </div>
            </div>
            <div className="bg-primary100 rounded-lg p-6 flex gap-3 items-start">
              <img src={images.payment_icon} alt="refund icon" />
              <div className="flex flex-col gap-3">
                <p className="font-light md:text-2xl text-lg md:leading-[100%] leading-[25px] text-secondary100">
                  Payment secured by Stripe
                </p>
                <p className="font-light md:text-base text-sm md:leading-[21px] leading-[19px] text-secondary100 max-w-[530px]">
                  The same payment processor Apple, Amazon, Etsy, Walmart &
                  Target use. No credit card details seen or stored by us!
                </p>
              </div>
            </div>
          </div>
          <Footer />
        </div>
      </div>
    </Fragment>
  );
};

export default ReservationPage;
